import React, { Component } from 'react'
import { AppContext } from '@lightspeed-invoicing/core-client/frontend'
import { injectIntl } from 'react-intl'
import $ from "jquery";
import LoadingSpinner from "../../common/spinner/loading.component.jsx";
import GlobalHelper from "../../common/GlobalHelper.jsx";
import SendEmailModal from "../../common/email/sendemail.component.jsx";
const queryString = require('query-string')

class SendInvoiceEmailModalEmbed extends Component {

    constructor(props, context) {
        super(props, context)
        const uri = queryString.parse(this.props.location.search)
        this.state = {
            className: this.props.className || '',
            contactId: this.props.contactId || '',
            hash: uri.hash,
            invoiceId: uri.invoiceId,
            contact: null,
            locationId :'',
            proposal: null,
            loading: true,
        }
        this.closeModal = this.closeModal.bind(this)
        this.updateSize = this.updateSize.bind(this)
        this.handleCloseModal = this.handleCloseModal.bind(this)
        this.sendProposal = this.sendProposal.bind(this)
    }

    componentDidMount() {
        this.updateSize()
        AppContext.getApiClient().get(`/invoices/${this.state.invoiceId}`).then(res => {
            this.setState({
                loading: false,
                contact: res.attributes.contact,
                locationId: res.attributes.locationId,
            }, () => {
                setTimeout(this.updateSize, 100)
            })
        })
        AppContext.getApiClient().get(`/proposals/${this.state.hash}`).then(res => {
            this.setState({
                loading: false,
                proposal: res,
            })
        })
    }


    closeModal() {
        const data = {
            type: "qm-close-iframe-modal",
        }
        parent.postMessage(data, "*")
    }

    updateSize() {
        let size = 150
        const elem = document.getElementById('QuoteMachineSendInvoiceEmailEmbedModal')
        if (elem) {
            size = elem.offsetHeight
        }
        const data = {
            type: "qm-size-iframe-modal",
            text: JSON.stringify({
                width: '800px',
                height: `${size}px`,
                padding: '0px',
            })
        }
        parent.postMessage(data, "*")
        $('body').css('overflow', 'hidden')
    }


    sendProposal(subject, toEmail, ccEmail, content, buttonLabel, pdfIncluded, templateKey, fromEmail, bccEmail) {
        window.scrollTo(0, 0)
        AppContext.getApiClient().post('/proposals/' + this.state.hash + '/send-by-email', {
            subject: subject,
            toEmail: toEmail,
            ccEmail: ccEmail,
            content: content,
            buttonLabel: buttonLabel,
            attachments: pdfIncluded ?
                [
                    {
                        name: this.state.proposal.attributes.variables.document.reference.concat(".pdf"),
                        fileLink: this.state.proposal.attributes.variables.document.pdfUri,
                        contentType: "application/pdf",
                    }
                ] : [],
            fromEmail: fromEmail,
            bccEmail: bccEmail,
        }).then(res => {
            this.closeModal()
        })
    }

    handleCloseModal() {
        this.closeModal()
    }

    getCustomerEmailAddresses() {
        return GlobalHelper.formatContactEmail(this.state.contact.attributes.email, this.state.contact.attributes.name)
    }

    render() {
        if (this.state.loading) {
            return <LoadingSpinner />
        }
        return <div id="QuoteMachineSendInvoiceEmailEmbedModal">
            <SendEmailModal
                noModal={true}
                onSubmit={this.sendProposal}
                onClose={this.handleCloseModal}
                locationId={this.state.locationId}
                toEmail={this.getCustomerEmailAddresses()}
                pdfIncluded={this.pdfIncluded}
                proposalType={'invoice'}
                templateKey={'send-invoice'}
            />
        </div>
    }
}

export default injectIntl(SendInvoiceEmailModalEmbed)





// WEBPACK FOOTER //
// ./src/embed/ls-retail/sendinvoiceemailmodal.component.jsx